import { FiShoppingBag } from "react-icons/fi";
import { TbMotorbike } from "react-icons/tb";
import { SiIfood } from "react-icons/si";

export function OrderChannelIcon({ channel }) {
  const Icon = channel === 'ifood' ? SiIfood : channel === 'retirada' ? FiShoppingBag : TbMotorbike;

  return (
    <span className={`order-channel-icon order-channel-icon-${channel}`} aria-hidden="true">
      <Icon size={23} />
    </span>
  );
}
